import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const documentosRoutes: Routes = [
  {
    path: 'documentos',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Gerenciar Documentos',
      breadcrumb: [{ label: 'Documentos' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./documentos').then((m) => m.Documentos),
        data: {
          title: 'Gerenciar Documentos',
          roles: [Role.TIPO_DOCUMENTO_CONSULTAR],
          breadcrumb: [{ label: 'Documentos', url: '/documentos' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./cadastrar-documento/cadastrar-documento.dialog').then(
            (m) => m.CadastrarDocumentoDialog,
          ),
        data: {
          title: 'Cadastrar Documento',
          roles: [Role.TIPO_DOCUMENTO_CADASTRAR],
          breadcrumb: [
            { label: 'Documentos', url: '/documentos' },
            { label: 'Cadastrar', url: '/documentos/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./editar-documento/editar-documento.dialog').then(
            (m) => m.EditarDocumentoDialog,
          ),
        data: {
          title: 'Editar Documento',
          roles: [Role.TIPO_DOCUMENTO_EDITAR],
          breadcrumb: [
            { label: 'Documentos', url: '/documentos' },
            { label: 'Editar', url: '/documentos/editar' },
          ],
        },
      },
    ],
  },
];
